const portalOrigin = typeof window !== 'undefined' ? window.location.origin : 'https://devportal.unitedteambuilding.com';

export const environment = {
  production: false,
  devSimulateAuth: false,
  msal: {
    clientId: '20994869-0319-4242-acd9-fbddc4a6db5b',
    authority: 'https://UnitedTeamBuildingCIAM.ciamlogin.com/71c7c81e-efab-433f-80e3-e6c7b3314c11',
    redirectUri: `${portalOrigin}/`,
    postLogoutRedirectUri: `${portalOrigin}/`
  },
  msalConfig: {
    auth: {
      clientId: '20994869-0319-4242-acd9-fbddc4a6db5b',
      authority: 'https://UnitedTeamBuildingCIAM.ciamlogin.com/71c7c81e-efab-433f-80e3-e6c7b3314c11'
    }
  },
  apiConfig: {
    scopes: ['api://efc1e411-0d2e-4bab-a36b-deaf693abadd/access_as_user'],
    uri: 'https://unitedteambuildingdev-api.azurewebsites.net'
  },
  api: {
    baseUrl: 'https://unitedteambuildingdev-api.azurewebsites.net',
    scope: 'api://efc1e411-0d2e-4bab-a36b-deaf693abadd/access_as_user'
  },
  helcimPay: {
    enabled: true,
    scriptUrl: 'https://secure.helcim.app/helcim-pay/services/start.js',
    allowedOrigins: ['https://secure.helcim.app', 'https://helcim.app', 'https://api.helcim.app'],
    modalTimeoutMs: 120000
  },
  envName: 'development',
  tenantId: '71c7c81e-efab-433f-80e3-e6c7b3314c11',
  tenantDomain: 'unitedteambuildingciam.ciamlogin.com',
  userJourney: 'EmailOTP',
  knownAuthorities: 'unitedteambuildingciam.ciamlogin.com',
  apiBaseUrl: 'https://unitedteambuildingdev-api.azurewebsites.net'
};
